export enum routePath {
  NON_MANAGED_CAMPAIGN = "/settings/unmange-campaign",
  PROJECTS = "/projects",
  PROJECT_DATA = "/project-data",
  PROJECT_DATA_SETTINGS = "/project-data-settings",
}
